export default "__VITE_ASSET__CPwWP3h0__"